const SectionLoader = () => {
  return (
    <div className="pr-4">
      <div className="flex w-full animate-pulse flex-col space-y-6">
        <div className="space-y-4">
          <div className="h-6 w-full rounded bg-gray-200" />
          <div className="h-6 w-full rounded bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default SectionLoader;
